// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `

:root {
  --bv-primary: #14b8a6;
  --bv-primary-600: #0d9488;
  --bv-primary-700: #0f766e;
  --bv-primary-800: #115e59;
  --bv-primary-100: #ccfbf1;
  --bv-primary-50:  #e6f7f5;
  --bv-primary-line: #b8ebe4;

  --bv-accent:    #fb923c;   /* warm orange */
  --bv-accent-2:  #f59e0b;   /* amber */
  --bv-success:   #22c55e;
  --bv-danger:    #ef4444;
  --bv-info:      #3b82f6;
  --bv-star:      #facc15;

  --bv-ink:       #0f172a;
  --bv-ink-2:     #1e293b;
  --bv-ink-3:     #334155;
  --bv-muted:     #64748b;
  --bv-muted-2:   #94a3b8;
  --bv-line:      #e2e8f0;
  --bv-line-soft: #f1f5f9;
  --bv-bg:        #ffffff;
  --bv-bg-soft:   #f8fafc;
  --bv-bg-cream:  #f7faf9;
  --bv-white:     #ffffff;

  /* ---- Gradients ---- */
  --bv-grad-primary: linear-gradient(135deg, #14b8a6 0%, #0d9488 100%);
  --bv-grad-text:    linear-gradient(135deg, #0d9488 0%, #14b8a6 55%, #5eead4 100%);
  --bv-grad-soft:    linear-gradient(135deg, #e6f7f5 0%, #ccfbf1 100%);
  --bv-grad-dark:    linear-gradient(135deg, #0f172a 0%, #1e293b 100%);

  /* ============ TYPOGRAPHY ============ */
  --bv-font-display: "Plus Jakarta Sans", "Poppins", system-ui, -apple-system, "Segoe UI", Roboto, sans-serif;
  --bv-font-body:    "Inter", "Plus Jakarta Sans", "Poppins", system-ui, -apple-system, "Segoe UI", Roboto, sans-serif;
  --bv-font-script:  "Caveat", cursive;

  --bv-text-xs:   0.75rem;
  --bv-text-sm:   0.875rem;
  --bv-text-base: 1rem;
  --bv-text-lg:   1.125rem;
  --bv-text-xl:   1.25rem;
  --bv-text-2xl:  1.5rem;
  --bv-text-3xl:  clamp(1.625rem, 2.4vw, 2.125rem);
  --bv-text-4xl:  clamp(2rem, 3vw, 2.75rem);
  --bv-display:   clamp(2.4rem, 5vw, 4.75rem);
  --bv-display-script: clamp(2.6rem, 5.3vw, 4.8rem);

  /* ============ SPACING SCALE ============ */
  --bv-space-1:  0.25rem;
  --bv-space-2:  0.5rem;
  --bv-space-3:  0.75rem;
  --bv-space-4:  1rem;
  --bv-space-5:  1.25rem;
  --bv-space-6:  1.5rem;
  --bv-space-7:  2rem;
  --bv-space-8:  2.5rem;
  --bv-space-9:  3rem;
  --bv-space-10: 4rem;
  --bv-space-11: 5rem;
  --bv-space-12: 6rem;

  /* Layout primitives */
  --bv-section-y:    clamp(3.5rem, 6vw, 6rem);
  --bv-container-px: clamp(1rem, 2.4vw, 2rem);
  --bv-container-max: 1280px;
  --bv-container-wide: 1600px;

  /* ============ RADII ============ */
  --bv-radius-xs:   6px;
  --bv-radius-sm:   10px;
  --bv-radius:      14px;
  --bv-radius-lg:   18px;
  --bv-radius-xl:   24px;
  --bv-radius-2xl:  32px;
  --bv-radius-pill: 999px;

  /* ============ SHADOWS ============ */
  --bv-shadow-xs:   0 1px 2px rgba(15, 23, 42, 0.05);
  --bv-shadow-sm:   0 2px 8px rgba(15, 23, 42, 0.06);
  --bv-shadow:      0 8px 24px rgba(15, 23, 42, 0.08);
  --bv-shadow-md:   0 14px 36px rgba(15, 23, 42, 0.10);
  --bv-shadow-lg:   0 24px 60px rgba(15, 23, 42, 0.16);
  --bv-shadow-xl:   0 36px 80px rgba(15, 23, 42, 0.20);
  --bv-shadow-teal: 0 18px 44px rgba(20, 184, 166, 0.30);
  --bv-shadow-card-hover: 0 28px 60px rgba(15, 23, 42, 0.18);

  /* ============ MOTION ============ */
  --bv-ease:        cubic-bezier(0.4, 0, 0.2, 1);
  --bv-ease-out:    cubic-bezier(0.16, 1, 0.3, 1);
  --bv-ease-spring: cubic-bezier(0.34, 1.56, 0.64, 1);
  --bv-dur-fast:    180ms;
  --bv-dur:         280ms;
  --bv-dur-slow:    480ms;

  /* ============ Z-INDEX ============ */
  --bv-z-nav:    50;
  --bv-z-modal:  100;
  --bv-z-toast:  200;
}

/* ================================================================
   GLOBAL TYPOGRAPHY & BASE
   ================================================================ */
*,
*::before,
*::after { box-sizing: border-box; }

html { scroll-behavior: smooth; }

body {
  font-family: var(--bv-font-body);
  font-size: var(--bv-text-base);
  line-height: 1.6;
  color: var(--bv-ink-2);
  background: var(--bv-bg);
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

h1, h2, h3, h4, h5, h6 {
  font-family: var(--bv-font-display);
  color: var(--bv-ink);
  font-weight: 700;
  line-height: 1.2;
  letter-spacing: -0.01em;
  margin: 0;
}

p { margin: 0; }
a  { text-decoration: none; color: inherit; }
button { font-family: inherit; cursor: pointer; }
img { max-width: 100%; display: block; }

/* Utility text gradient */
.bv-grad-text,
.gradientText {
  background: var(--bv-grad-text);
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
  color: transparent;
}

/* Reusable container — padding inside max-width; outer cap matches header/footer shell */
.bv-container {
  width: 100%;
  max-width: calc(var(--bv-container-max) + (2 * var(--bv-container-px)));
  margin-inline: auto;
  padding-inline: var(--bv-container-px);
  box-sizing: border-box;
}
.bv-container--wide {
  max-width: calc(var(--bv-container-wide) + (2 * var(--bv-container-px)));
}

/* Reusable section eyebrow / heading block */
.bv-section {
  padding-block: var(--bv-section-y);
}

.bv-section--cream { background: var(--bv-bg-cream); }
.bv-section--soft  { background: var(--bv-bg-soft); }

.bv-section-head {
  text-align: center;
  margin-bottom: var(--bv-space-9);
  max-width: 720px;
  margin-inline: auto;
}
.bv-section-eyebrow {
  display: inline-flex;
  align-items: center;
  gap: var(--bv-space-2);
  padding: 6px 14px;
  border-radius: var(--bv-radius-pill);
  background: var(--bv-primary-50);
  color: var(--bv-primary-700);
  border: 1px solid var(--bv-primary-line);
  font-size: var(--bv-text-sm);
  font-weight: 600;
  margin-bottom: var(--bv-space-4);
}
/* Unified section headings — same look as FAQ ("Frequently Asked Questions") */
.bv-section-title,
.bv-section-head h2,
.section-heading h2 {
  font-family: var(--bv-font-display);
  font-size: var(--bv-text-4xl);
  font-weight: 700;
  letter-spacing: -0.025em;
  line-height: 1.15;
  color: var(--bv-ink);
  margin: 0;
}

.bv-section-head p {
  margin-top: var(--bv-space-3);
  color: var(--bv-muted);
  font-size: var(--bv-text-lg);
}

/* Generic primary button */
.bv-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: var(--bv-space-2);
  font-family: var(--bv-font-display);
  font-weight: 600;
  font-size: var(--bv-text-base);
  padding: 0.75rem 1.5rem;
  border-radius: var(--bv-radius-pill);
  border: 1px solid transparent;
  cursor: pointer;
  transition: transform var(--bv-dur) var(--bv-ease),
              box-shadow var(--bv-dur) var(--bv-ease),
              background var(--bv-dur) var(--bv-ease),
              color var(--bv-dur) var(--bv-ease);
  text-decoration: none;
  line-height: 1;
}
.bv-btn--primary {
  background: var(--bv-grad-primary);
  color: #fff;
  box-shadow: var(--bv-shadow-teal);
}
.bv-btn--primary:hover {
  transform: translateY(-2px);
  box-shadow: 0 22px 48px rgba(20, 184, 166, 0.36);
  color: #fff;
}
.bv-btn--dark {
  background: var(--bv-ink);
  color: #fff;
}
.bv-btn--dark:hover {
  background: var(--bv-ink-2);
  transform: translateY(-2px);
  color: #fff;
}
.bv-btn--ghost {
  background: #fff;
  border-color: var(--bv-line);
  color: var(--bv-ink);
}
.bv-btn--ghost:hover {
  border-color: var(--bv-primary);
  color: var(--bv-primary-700);
  transform: translateY(-2px);
}

/* Tag / Pill chip */
.bv-pill {
  display: inline-flex;
  align-items: center;
  gap: var(--bv-space-2);
  padding: 6px 12px;
  border-radius: var(--bv-radius-pill);
  background: rgba(255,255,255,0.9);
  border: 1px solid var(--bv-line);
  color: var(--bv-ink-2);
  font-size: var(--bv-text-sm);
  font-weight: 600;
}

/* Animations */
@keyframes bvFloat {
  0%, 100% { transform: translateY(0); }
  50%      { transform: translateY(-14px); }
}
@keyframes bvFloatSpin {
  0%   { transform: translateY(0) rotate(0deg); }
  50%  { transform: translateY(-14px) rotate(8deg); }
  100% { transform: translateY(0) rotate(0deg); }
}
@keyframes bvFadeUp {
  from { opacity: 0; transform: translateY(20px); }
  to   { opacity: 1; transform: translateY(0); }
}
@keyframes bvFadeIn {
  from { opacity: 0; }
  to   { opacity: 1; }
}
@keyframes bvScaleIn {
  from { opacity: 0; transform: scale(0.92); }
  to   { opacity: 1; transform: scale(1); }
}
@keyframes bvPulseRing {
  0%   { box-shadow: 0 0 0 0 rgba(20, 184, 166, 0.40); }
  70%  { box-shadow: 0 0 0 18px rgba(20, 184, 166, 0.0); }
  100% { box-shadow: 0 0 0 0 rgba(20, 184, 166, 0.0); }
}

/* ============ SCROLL REVEAL ============ */
.bv-reveal {
  opacity: 0;
  transform: translateY(28px);
  transition: opacity 0.7s var(--bv-ease-out),
              transform 0.8s var(--bv-ease-out);
  will-change: opacity, transform;
}
.bv-reveal--left  { transform: translateX(-28px); }
.bv-reveal--right { transform: translateX(28px); }
.bv-reveal--scale { transform: scale(0.94); }
.bv-reveal.is-revealed,
.bv-reveal--left.is-revealed,
.bv-reveal--right.is-revealed,
.bv-reveal--scale.is-revealed {
  opacity: 1;
  transform: none;
}
.bv-reveal[data-delay="100"] { transition-delay: 100ms; }
.bv-reveal[data-delay="200"] { transition-delay: 200ms; }
.bv-reveal[data-delay="300"] { transition-delay: 300ms; }
.bv-reveal[data-delay="400"] { transition-delay: 400ms; }

/* Accessibility: respect reduced motion */
@media (prefers-reduced-motion: reduce) {
  *, *::before, *::after {
    animation-duration: 0.01ms !important;
    animation-iteration-count: 1 !important;
    transition-duration: 0.01ms !important;
    scroll-behavior: auto !important;
  }
  .bv-reveal,
  .bv-reveal--left,
  .bv-reveal--right,
  .bv-reveal--scale { opacity: 1; transform: none; }
}
`, "",{"version":3,"sources":["webpack://./src/css/theme.css"],"names":[],"mappings":";;AAEA;EACE,qBAAqB;EACrB,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,0BAA0B;;EAE1B,uBAAuB,IAAI,gBAAgB;EAC3C,uBAAuB,IAAI,UAAU;EACrC,uBAAuB;EACvB,uBAAuB;EACvB,uBAAuB;EACvB,uBAAuB;;EAEvB,uBAAuB;EACvB,uBAAuB;EACvB,uBAAuB;EACvB,uBAAuB;EACvB,uBAAuB;EACvB,uBAAuB;EACvB,uBAAuB;EACvB,uBAAuB;EACvB,uBAAuB;EACvB,uBAAuB;EACvB,uBAAuB;;EAEvB,wBAAwB;EACxB,oEAAoE;EACpE,iFAAiF;EACjF,oEAAoE;EACpE,oEAAoE;;EAEpE,yCAAyC;EACzC,2GAA2G;EAC3G,oHAAoH;EACpH,oCAAoC;;EAEpC,uBAAuB;EACvB,wBAAwB;EACxB,oBAAoB;EACpB,wBAAwB;EACxB,uBAAuB;EACvB,sBAAsB;EACtB,gDAAgD;EAChD,yCAAyC;EACzC,2CAA2C;EAC3C,iDAAiD;;EAEjD,4CAA4C;EAC5C,sBAAsB;EACtB,qBAAqB;EACrB,sBAAsB;EACtB,mBAAmB;EACnB,sBAAsB;EACtB,qBAAqB;EACrB,mBAAmB;EACnB,qBAAqB;EACrB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;;EAEnB,sBAAsB;EACtB,2CAA2C;EAC3C,2CAA2C;EAC3C,0BAA0B;EAC1B,2BAA2B;;EAE3B,oCAAoC;EACpC,qBAAqB;EACrB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,uBAAuB;;EAEvB,sCAAsC;EACtC,kDAAkD;EAClD,kDAAkD;EAClD,mDAAmD;EACnD,oDAAoD;EACpD,oDAAoD;EACpD,oDAAoD;EACpD,sDAAsD;EACtD,0DAA0D;;EAE1D,qCAAqC;EACrC,8CAA8C;EAC9C,+CAA+C;EAC/C,mDAAmD;EACnD,uBAAuB;EACvB,uBAAuB;EACvB,uBAAuB;;EAEvB,sCAAsC;EACtC,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;;qEAEqE;AACrE;;WAEW,sBAAsB,EAAE;;AAEnC,OAAO,uBAAuB,EAAE;;AAEhC;EACE,gCAAgC;EAChC,8BAA8B;EAC9B,gBAAgB;EAChB,sBAAsB;EACtB,wBAAwB;EACxB,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;EACE,mCAAmC;EACnC,oBAAoB;EACpB,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,SAAS;AACX;;AAEA,IAAI,SAAS,EAAE;AACf,KAAK,qBAAqB,EAAE,cAAc,EAAE;AAC5C,SAAS,oBAAoB,EAAE,eAAe,EAAE;AAChD,MAAM,eAAe,EAAE,cAAc,EAAE;;AAEvC,0BAA0B;AAC1B;;EAEE,+BAA+B;EAC/B,6BAA6B;EAC7B,qBAAqB;EACrB,oCAAoC;EACpC,kBAAkB;AACpB;;AAEA,yFAAyF;AACzF;EACE,WAAW;EACX,uEAAuE;EACvE,mBAAmB;EACnB,sCAAsC;EACtC,sBAAsB;AACxB;AACA;EACE,wEAAwE;AAC1E;;AAEA,6CAA6C;AAC7C;EACE,kCAAkC;AACpC;;AAEA,qBAAqB,8BAA8B,EAAE;AACrD,qBAAqB,6BAA6B,EAAE;;AAEpD;EACE,kBAAkB;EAClB,gCAAgC;EAChC,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,sBAAsB;EACtB,iBAAiB;EACjB,oCAAoC;EACpC,gCAAgC;EAChC,4BAA4B;EAC5B,wCAAwC;EACxC,4BAA4B;EAC5B,gBAAgB;EAChB,gCAAgC;AAClC;AACA,+EAA+E;AAC/E;;;EAGE,mCAAmC;EACnC,6BAA6B;EAC7B,gBAAgB;EAChB,wBAAwB;EACxB,iBAAiB;EACjB,oBAAoB;EACpB,SAAS;AACX;;AAEA;EACE,6BAA6B;EAC7B,sBAAsB;EACtB,4BAA4B;AAC9B;;AAEA,2BAA2B;AAC3B;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,mCAAmC;EACnC,gBAAgB;EAChB,8BAA8B;EAC9B,uBAAuB;EACvB,oCAAoC;EACpC,6BAA6B;EAC7B,eAAe;EACf;;;gDAG8C;EAC9C,qBAAqB;EACrB,cAAc;AAChB;AACA;EACE,kCAAkC;EAClC,WAAW;EACX,iCAAiC;AACnC;AACA;EACE,2BAA2B;EAC3B,gDAAgD;EAChD,WAAW;AACb;AACA;EACE,yBAAyB;EACzB,WAAW;AACb;AACA;EACE,2BAA2B;EAC3B,2BAA2B;EAC3B,WAAW;AACb;AACA;EACE,gBAAgB;EAChB,4BAA4B;EAC5B,oBAAoB;AACtB;AACA;EACE,+BAA+B;EAC/B,4BAA4B;EAC5B,2BAA2B;AAC7B;;AAEA,oBAAoB;AACpB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,sBAAsB;EACtB,iBAAiB;EACjB,oCAAoC;EACpC,iCAAiC;EACjC,gCAAgC;EAChC,sBAAsB;EACtB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA,eAAe;AACf;EACE,WAAW,wBAAwB,EAAE;EACrC,WAAW,4BAA4B,EAAE;AAC3C;AACA;EACE,OAAO,qCAAqC,EAAE;EAC9C,OAAO,yCAAyC,EAAE;EAClD,OAAO,qCAAqC,EAAE;AAChD;AACA;EACE,OAAO,UAAU,EAAE,2BAA2B,EAAE;EAChD,OAAO,UAAU,EAAE,wBAAwB,EAAE;AAC/C;AACA;EACE,OAAO,UAAU,EAAE;EACnB,OAAO,UAAU,EAAE;AACrB;AACA;EACE,OAAO,UAAU,EAAE,sBAAsB,EAAE;EAC3C,OAAO,UAAU,EAAE,mBAAmB,EAAE;AAC1C;AACA;EACE,OAAO,4CAA4C,EAAE;EACrD,OAAO,8CAA8C,EAAE;EACvD,OAAO,2CAA2C,EAAE;AACtD;;AAEA,4CAA4C;AAC5C;EACE,UAAU;EACV,2BAA2B;EAC3B;+CAC6C;EAC7C,+BAA+B;AACjC;AACA,oBAAoB,4BAA4B,EAAE;AAClD,oBAAoB,2BAA2B,EAAE;AACjD,oBAAoB,sBAAsB,EAAE;AAC5C;;;;EAIE,UAAU;EACV,eAAe;AACjB;AACA,+BAA+B,uBAAuB,EAAE;AACxD,+BAA+B,uBAAuB,EAAE;AACxD,+BAA+B,uBAAuB,EAAE;AACxD,+BAA+B,uBAAuB,EAAE;;AAExD,0CAA0C;AAC1C;EACE;IACE,qCAAqC;IACrC,uCAAuC;IACvC,sCAAsC;IACtC,gCAAgC;EAClC;EACA;;;sBAGoB,UAAU,EAAE,eAAe,EAAE;AACnD","sourcesContent":["\n\n:root {\n  --bv-primary: #14b8a6;\n  --bv-primary-600: #0d9488;\n  --bv-primary-700: #0f766e;\n  --bv-primary-800: #115e59;\n  --bv-primary-100: #ccfbf1;\n  --bv-primary-50:  #e6f7f5;\n  --bv-primary-line: #b8ebe4;\n\n  --bv-accent:    #fb923c;   /* warm orange */\n  --bv-accent-2:  #f59e0b;   /* amber */\n  --bv-success:   #22c55e;\n  --bv-danger:    #ef4444;\n  --bv-info:      #3b82f6;\n  --bv-star:      #facc15;\n\n  --bv-ink:       #0f172a;\n  --bv-ink-2:     #1e293b;\n  --bv-ink-3:     #334155;\n  --bv-muted:     #64748b;\n  --bv-muted-2:   #94a3b8;\n  --bv-line:      #e2e8f0;\n  --bv-line-soft: #f1f5f9;\n  --bv-bg:        #ffffff;\n  --bv-bg-soft:   #f8fafc;\n  --bv-bg-cream:  #f7faf9;\n  --bv-white:     #ffffff;\n\n  /* ---- Gradients ---- */\n  --bv-grad-primary: linear-gradient(135deg, #14b8a6 0%, #0d9488 100%);\n  --bv-grad-text:    linear-gradient(135deg, #0d9488 0%, #14b8a6 55%, #5eead4 100%);\n  --bv-grad-soft:    linear-gradient(135deg, #e6f7f5 0%, #ccfbf1 100%);\n  --bv-grad-dark:    linear-gradient(135deg, #0f172a 0%, #1e293b 100%);\n\n  /* ============ TYPOGRAPHY ============ */\n  --bv-font-display: \"Plus Jakarta Sans\", \"Poppins\", system-ui, -apple-system, \"Segoe UI\", Roboto, sans-serif;\n  --bv-font-body:    \"Inter\", \"Plus Jakarta Sans\", \"Poppins\", system-ui, -apple-system, \"Segoe UI\", Roboto, sans-serif;\n  --bv-font-script:  \"Caveat\", cursive;\n\n  --bv-text-xs:   0.75rem;\n  --bv-text-sm:   0.875rem;\n  --bv-text-base: 1rem;\n  --bv-text-lg:   1.125rem;\n  --bv-text-xl:   1.25rem;\n  --bv-text-2xl:  1.5rem;\n  --bv-text-3xl:  clamp(1.625rem, 2.4vw, 2.125rem);\n  --bv-text-4xl:  clamp(2rem, 3vw, 2.75rem);\n  --bv-display:   clamp(2.4rem, 5vw, 4.75rem);\n  --bv-display-script: clamp(2.6rem, 5.3vw, 4.8rem);\n\n  /* ============ SPACING SCALE ============ */\n  --bv-space-1:  0.25rem;\n  --bv-space-2:  0.5rem;\n  --bv-space-3:  0.75rem;\n  --bv-space-4:  1rem;\n  --bv-space-5:  1.25rem;\n  --bv-space-6:  1.5rem;\n  --bv-space-7:  2rem;\n  --bv-space-8:  2.5rem;\n  --bv-space-9:  3rem;\n  --bv-space-10: 4rem;\n  --bv-space-11: 5rem;\n  --bv-space-12: 6rem;\n\n  /* Layout primitives */\n  --bv-section-y:    clamp(3.5rem, 6vw, 6rem);\n  --bv-container-px: clamp(1rem, 2.4vw, 2rem);\n  --bv-container-max: 1280px;\n  --bv-container-wide: 1600px;\n\n  /* ============ RADII ============ */\n  --bv-radius-xs:   6px;\n  --bv-radius-sm:   10px;\n  --bv-radius:      14px;\n  --bv-radius-lg:   18px;\n  --bv-radius-xl:   24px;\n  --bv-radius-2xl:  32px;\n  --bv-radius-pill: 999px;\n\n  /* ============ SHADOWS ============ */\n  --bv-shadow-xs:   0 1px 2px rgba(15, 23, 42, 0.05);\n  --bv-shadow-sm:   0 2px 8px rgba(15, 23, 42, 0.06);\n  --bv-shadow:      0 8px 24px rgba(15, 23, 42, 0.08);\n  --bv-shadow-md:   0 14px 36px rgba(15, 23, 42, 0.10);\n  --bv-shadow-lg:   0 24px 60px rgba(15, 23, 42, 0.16);\n  --bv-shadow-xl:   0 36px 80px rgba(15, 23, 42, 0.20);\n  --bv-shadow-teal: 0 18px 44px rgba(20, 184, 166, 0.30);\n  --bv-shadow-card-hover: 0 28px 60px rgba(15, 23, 42, 0.18);\n\n  /* ============ MOTION ============ */\n  --bv-ease:        cubic-bezier(0.4, 0, 0.2, 1);\n  --bv-ease-out:    cubic-bezier(0.16, 1, 0.3, 1);\n  --bv-ease-spring: cubic-bezier(0.34, 1.56, 0.64, 1);\n  --bv-dur-fast:    180ms;\n  --bv-dur:         280ms;\n  --bv-dur-slow:    480ms;\n\n  /* ============ Z-INDEX ============ */\n  --bv-z-nav:    50;\n  --bv-z-modal:  100;\n  --bv-z-toast:  200;\n}\n\n/* ================================================================\n   GLOBAL TYPOGRAPHY & BASE\n   ================================================================ */\n*,\n*::before,\n*::after { box-sizing: border-box; }\n\nhtml { scroll-behavior: smooth; }\n\nbody {\n  font-family: var(--bv-font-body);\n  font-size: var(--bv-text-base);\n  line-height: 1.6;\n  color: var(--bv-ink-2);\n  background: var(--bv-bg);\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\nh1, h2, h3, h4, h5, h6 {\n  font-family: var(--bv-font-display);\n  color: var(--bv-ink);\n  font-weight: 700;\n  line-height: 1.2;\n  letter-spacing: -0.01em;\n  margin: 0;\n}\n\np { margin: 0; }\na  { text-decoration: none; color: inherit; }\nbutton { font-family: inherit; cursor: pointer; }\nimg { max-width: 100%; display: block; }\n\n/* Utility text gradient */\n.bv-grad-text,\n.gradientText {\n  background: var(--bv-grad-text);\n  -webkit-background-clip: text;\n  background-clip: text;\n  -webkit-text-fill-color: transparent;\n  color: transparent;\n}\n\n/* Reusable container — padding inside max-width; outer cap matches header/footer shell */\n.bv-container {\n  width: 100%;\n  max-width: calc(var(--bv-container-max) + (2 * var(--bv-container-px)));\n  margin-inline: auto;\n  padding-inline: var(--bv-container-px);\n  box-sizing: border-box;\n}\n.bv-container--wide {\n  max-width: calc(var(--bv-container-wide) + (2 * var(--bv-container-px)));\n}\n\n/* Reusable section eyebrow / heading block */\n.bv-section {\n  padding-block: var(--bv-section-y);\n}\n\n.bv-section--cream { background: var(--bv-bg-cream); }\n.bv-section--soft  { background: var(--bv-bg-soft); }\n\n.bv-section-head {\n  text-align: center;\n  margin-bottom: var(--bv-space-9);\n  max-width: 720px;\n  margin-inline: auto;\n}\n.bv-section-eyebrow {\n  display: inline-flex;\n  align-items: center;\n  gap: var(--bv-space-2);\n  padding: 6px 14px;\n  border-radius: var(--bv-radius-pill);\n  background: var(--bv-primary-50);\n  color: var(--bv-primary-700);\n  border: 1px solid var(--bv-primary-line);\n  font-size: var(--bv-text-sm);\n  font-weight: 600;\n  margin-bottom: var(--bv-space-4);\n}\n/* Unified section headings — same look as FAQ (\"Frequently Asked Questions\") */\n.bv-section-title,\n.bv-section-head h2,\n.section-heading h2 {\n  font-family: var(--bv-font-display);\n  font-size: var(--bv-text-4xl);\n  font-weight: 700;\n  letter-spacing: -0.025em;\n  line-height: 1.15;\n  color: var(--bv-ink);\n  margin: 0;\n}\n\n.bv-section-head p {\n  margin-top: var(--bv-space-3);\n  color: var(--bv-muted);\n  font-size: var(--bv-text-lg);\n}\n\n/* Generic primary button */\n.bv-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: var(--bv-space-2);\n  font-family: var(--bv-font-display);\n  font-weight: 600;\n  font-size: var(--bv-text-base);\n  padding: 0.75rem 1.5rem;\n  border-radius: var(--bv-radius-pill);\n  border: 1px solid transparent;\n  cursor: pointer;\n  transition: transform var(--bv-dur) var(--bv-ease),\n              box-shadow var(--bv-dur) var(--bv-ease),\n              background var(--bv-dur) var(--bv-ease),\n              color var(--bv-dur) var(--bv-ease);\n  text-decoration: none;\n  line-height: 1;\n}\n.bv-btn--primary {\n  background: var(--bv-grad-primary);\n  color: #fff;\n  box-shadow: var(--bv-shadow-teal);\n}\n.bv-btn--primary:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 22px 48px rgba(20, 184, 166, 0.36);\n  color: #fff;\n}\n.bv-btn--dark {\n  background: var(--bv-ink);\n  color: #fff;\n}\n.bv-btn--dark:hover {\n  background: var(--bv-ink-2);\n  transform: translateY(-2px);\n  color: #fff;\n}\n.bv-btn--ghost {\n  background: #fff;\n  border-color: var(--bv-line);\n  color: var(--bv-ink);\n}\n.bv-btn--ghost:hover {\n  border-color: var(--bv-primary);\n  color: var(--bv-primary-700);\n  transform: translateY(-2px);\n}\n\n/* Tag / Pill chip */\n.bv-pill {\n  display: inline-flex;\n  align-items: center;\n  gap: var(--bv-space-2);\n  padding: 6px 12px;\n  border-radius: var(--bv-radius-pill);\n  background: rgba(255,255,255,0.9);\n  border: 1px solid var(--bv-line);\n  color: var(--bv-ink-2);\n  font-size: var(--bv-text-sm);\n  font-weight: 600;\n}\n\n/* Animations */\n@keyframes bvFloat {\n  0%, 100% { transform: translateY(0); }\n  50%      { transform: translateY(-14px); }\n}\n@keyframes bvFloatSpin {\n  0%   { transform: translateY(0) rotate(0deg); }\n  50%  { transform: translateY(-14px) rotate(8deg); }\n  100% { transform: translateY(0) rotate(0deg); }\n}\n@keyframes bvFadeUp {\n  from { opacity: 0; transform: translateY(20px); }\n  to   { opacity: 1; transform: translateY(0); }\n}\n@keyframes bvFadeIn {\n  from { opacity: 0; }\n  to   { opacity: 1; }\n}\n@keyframes bvScaleIn {\n  from { opacity: 0; transform: scale(0.92); }\n  to   { opacity: 1; transform: scale(1); }\n}\n@keyframes bvPulseRing {\n  0%   { box-shadow: 0 0 0 0 rgba(20, 184, 166, 0.40); }\n  70%  { box-shadow: 0 0 0 18px rgba(20, 184, 166, 0.0); }\n  100% { box-shadow: 0 0 0 0 rgba(20, 184, 166, 0.0); }\n}\n\n/* ============ SCROLL REVEAL ============ */\n.bv-reveal {\n  opacity: 0;\n  transform: translateY(28px);\n  transition: opacity 0.7s var(--bv-ease-out),\n              transform 0.8s var(--bv-ease-out);\n  will-change: opacity, transform;\n}\n.bv-reveal--left  { transform: translateX(-28px); }\n.bv-reveal--right { transform: translateX(28px); }\n.bv-reveal--scale { transform: scale(0.94); }\n.bv-reveal.is-revealed,\n.bv-reveal--left.is-revealed,\n.bv-reveal--right.is-revealed,\n.bv-reveal--scale.is-revealed {\n  opacity: 1;\n  transform: none;\n}\n.bv-reveal[data-delay=\"100\"] { transition-delay: 100ms; }\n.bv-reveal[data-delay=\"200\"] { transition-delay: 200ms; }\n.bv-reveal[data-delay=\"300\"] { transition-delay: 300ms; }\n.bv-reveal[data-delay=\"400\"] { transition-delay: 400ms; }\n\n/* Accessibility: respect reduced motion */\n@media (prefers-reduced-motion: reduce) {\n  *, *::before, *::after {\n    animation-duration: 0.01ms !important;\n    animation-iteration-count: 1 !important;\n    transition-duration: 0.01ms !important;\n    scroll-behavior: auto !important;\n  }\n  .bv-reveal,\n  .bv-reveal--left,\n  .bv-reveal--right,\n  .bv-reveal--scale { opacity: 1; transform: none; }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
